import { eArchiveApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { SchemeResponse } from 'src/types';

export const getSchemeListByCompanyId = (companyId: string, config: AxiosRequestConfig = {}) =>
  eArchiveApi.get<SchemeResponse[]>(`/api/v1/schemes/assignedToCompany/${companyId}`, config);
